export const ACCESS_TOKEN = 'AccessToken'
export const USER_EMAIL = 'user_email'
export const INITIALIZATION_DATE_CALL = 'initialization_date_call'
